import { render, staticRenderFns } from "./PhonesList.vue?vue&type=template&id=55e204fc&"
import script from "./PhonesList.vue?vue&type=script&lang=js&"
export * from "./PhonesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports